import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { 
  ArrowRight,
  Award,
  Heart,
  Users,
  GraduationCap,
  Mail,
  Phone
} from 'lucide-react';

const teamMembers = [
  {
    name: 'Lisa Martinolich',
    role: 'Chief Executive Officer',
    credentials: 'BSN, RN',
    image: 'https://static.wixstatic.com/media/7cfcc9_1b81a4dfdd14492b9d93d98ad5dd85a9~mv2.png/v1/fill/w_200,h_300,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/7cfcc9_1b81a4dfdd14492b9d93d98ad5dd85a9~mv2.png',
    bio: '',
    imageStyle: 'object-contain',
  },
  {
    name: 'Matthew Seymour',
    role: 'Chief Financial Officer',
    credentials: '',
    image: 'https://static.wixstatic.com/media/7cfcc9_dfb655abaea84305a058c6021a521193~mv2.jpeg/v1/fill/w_200,h_200,al_c,q_80,usm_0.66_1.00_0.01,enc_avif,quality_auto/7cfcc9_dfb655abaea84305a058c6021a521193~mv2.jpeg',
    bio: '',
  },
  {
    name: 'Emily Russell',
    role: 'Chief People Officer',
    credentials: 'MHA',
    image: 'https://static.wixstatic.com/media/7cfcc9_40161b11113449cda71123bf4beedae5~mv2.png/v1/fill/w_200,h_290,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/7cfcc9_40161b11113449cda71123bf4beedae5~mv2.png',
    bio: 'Emily is a seasoned HR and operations leader with extensive experience in healthcare and senior care organizations. She specializes in building scalable people operations, compliance-driven HR frameworks, and efficient onboarding and recruiting systems.',
  },
  {
    name: 'Jane Deale',
    role: 'VP of Sales & Training',
    credentials: '',
    image: 'https://images.unsplash.com/photo-1655249481446-25d575f1c054?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjB3b21hbiUyMGhlYWRzaG90JTIwYnVzaW5lc3MlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NzY4NjQ2NjR8MA&ixlib=rb-4.1.0&q=85',
    bio: 'Jane is a nurse with over 23 years of experience in healthcare and more than 22 years dedicated to coordinating home care services for seniors. She is the co-founder of Palm Beach County\'s largest senior healthcare networking group.',
  },
  {
    name: 'John Mullins',
    role: 'VP of Sales - Region 9',
    credentials: '',
    image: 'https://customer-assets.emergentagent.com/job_care-solutions-pro/artifacts/ea6a3n67_1769522547668.jpeg',
    bio: 'John Mullins is a senior care executive with over 20 years of experience in home health care, recognized for building high-performing teams, driving strategic partnerships, and delivering compassionate, results-focused care.',
    imageStyle: 'object-cover object-[center_25%]',
  },
  {
    name: 'Candace Smith',
    role: 'VP of Sales - Region 5 & 6',
    credentials: '',
    image: 'https://static.wixstatic.com/media/7cfcc9_5b0bc550fd824c5089b11d5c36bdb057~mv2.png/v1/fill/w_200,h_250,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/7cfcc9_5b0bc550fd824c5089b11d5c36bdb057~mv2.png',
    bio: 'With more than 15 years of experience in the home health industry. Driving growth through strong referral partnerships, team-focused leadership, and a deep understanding of home-based care, supported by a clinical background as an LPN.',
  },
  {
    name: 'Yvonne Buchs',
    role: 'VP of Operations West Coast',
    credentials: 'MSN, RN',
    image: 'https://images.unsplash.com/photo-1762522926984-e721bff0d6c6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjB3b21hbiUyMGV4ZWN1dGl2ZSUyMGhlYWRzaG90JTIwY29ycG9yYXRlfGVufDB8fHx8MTc3Njg2NDg0OXww&ixlib=rb-4.1.0&q=85',
    bio: 'Leading operations for Region 5, Region 6 & Region 7 on Florida\'s West Coast.',
  },
  {
    name: 'Natalie Buzzi',
    role: 'VP of Operations East Coast',
    credentials: 'RN',
    image: 'https://images.unsplash.com/photo-1758691737610-1f18e008f5f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjB3b21hbiUyMGV4ZWN1dGl2ZSUyMGhlYWRzaG90JTIwY29ycG9yYXRlfGVufDB8fHx8MTc3Njg2NDg0OXww&ixlib=rb-4.1.0&q=85',
    bio: 'Natalie serves as Vice President of Operations, leading with a deep commitment to compassionate, patient-centered care and operational excellence. With over 15 years of nursing and healthcare leadership experience.',
  },
  {
    name: 'Dominic Schneider',
    role: 'VP of Quality Assurance',
    credentials: 'RN',
    image: 'https://images.unsplash.com/photo-1576558656222-ba66febe3dec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBtYW4lMjBoZWFkc2hvdCUyMGJ1c2luZXNzJTIwcG9ydHJhaXR8ZW58MHx8fHwxNzc2ODY0NjY5fDA&ixlib=rb-4.1.0&q=85',
    bio: 'Registered nurse with 32 years of experience in Home Health care with 25 years in administrative roles. VP of Quality Assurance for Senior Care Solutions since 2023.',
  },
];

const values = [
  {
    icon: Heart,
    title: 'Compassion First',
    description: 'Our team approaches every patient with empathy and understanding.',
  },
  {
    icon: GraduationCap,
    title: 'Continuous Learning',
    description: 'We invest in ongoing education to provide the best care possible.',
  },
  {
    icon: Users,
    title: 'Team Collaboration',
    description: 'We work together to deliver comprehensive, coordinated care.',
  },
  {
    icon: Award,
    title: 'Excellence',
    description: 'We hold ourselves to the highest standards of professional practice.',
  },
];

export const Team = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-20 bg-[#000080]" data-testid="team-hero">
        <div className="absolute inset-0 bg-gradient-to-r from-[#000080] to-[#1E3A8A]"></div>
        <div className="container mx-auto px-4 md:px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <span className="inline-block text-[#34D399] font-semibold mb-4">OUR TEAM</span>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
              Meet Our Leadership
            </h1>
            <p className="text-xl text-white/80">
              Our team of dedicated healthcare professionals brings years of experience 
              and a genuine passion for helping seniors live their best lives at home.
            </p>
          </div>
        </div>
      </section>

      {/* Team Values */}
      <section className="py-12 bg-[#ECFDF5]" data-testid="team-values">
        <div className="container mx-auto px-4 md:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {values.map((value, index) => (
              <div key={value.title} className="text-center" data-testid={`team-value-${index}`}>
                <div className="w-14 h-14 rounded-full bg-[#00A878] flex items-center justify-center mx-auto mb-3">
                  <value.icon className="w-7 h-7 text-white" />
                </div>
                <h3 className="font-semibold text-[#0F172A] mb-1">{value.title}</h3>
                <p className="text-sm text-[#334155]">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team Members */}
      <section className="py-16 bg-white" data-testid="team-members">
        <div className="container mx-auto px-4 md:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-12">
            <span className="inline-block text-[#00A878] font-semibold mb-4">AGENCY CONTACTS</span>
            <h2 className="text-3xl md:text-4xl font-bold text-[#0F172A] mb-4">
              Our Leadership Team
            </h2>
            <p className="text-lg text-[#334155]">
              Meet the experienced healthcare professionals leading our organization.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {teamMembers.map((member, index) => (
              <Card 
                key={member.name}
                className="team-card bg-white border border-slate-100 overflow-hidden hover:shadow-lg transition-shadow"
                data-testid={`team-member-${index}`}
              >
                <div className="h-72 overflow-hidden bg-[#F8FAFC] flex items-center justify-center">
                  {member.image ? (
                    <img
                      src={member.image}
                      alt={member.name}
                      className={`w-full h-full ${member.imageStyle || 'object-cover object-[center_15%]'}`}
                    />
                  ) : (
                    <div className="w-24 h-24 rounded-full bg-[#00A878]/20 flex items-center justify-center">
                      <Users className="w-12 h-12 text-[#00A878]" />
                    </div>
                  )}
                </div>
                <CardContent className="p-5">
                  <h3 className="text-lg font-semibold text-[#0F172A]">
                    {member.name}
                    {member.credentials && <span className="text-[#00A878] font-normal">, {member.credentials}</span>}
                  </h3>
                  <p className="text-[#00A878] font-medium text-sm mb-2">{member.role}</p>
                  {member.bio && (
                    <p className="text-[#334155] text-sm leading-relaxed line-clamp-3">{member.bio}</p>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="py-16 bg-[#F8FAFC]" data-testid="team-contact">
        <div className="container mx-auto px-4 md:px-6 lg:px-8">
          <div className="bg-[#000080] rounded-2xl p-10 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-6">
              Get in Touch with Our Team
            </h2>
            <div className="flex flex-col sm:flex-row justify-center items-center gap-6 mb-8">
              <a 
                href="mailto:info@seniorcaresolutionsfl.com" 
                className="flex items-center gap-2 text-white hover:text-[#34D399] transition-colors"
              >
                <Mail className="w-5 h-5" />
                <span>info@seniorcaresolutionsfl.com</span>
              </a>
              <a 
                href="tel:+18773106120" 
                className="flex items-center gap-2 text-white hover:text-[#34D399] transition-colors"
              >
                <Phone className="w-5 h-5" />
                <span>877.310.6120</span>
              </a>
            </div>
            <Link to="/contact" data-testid="team-contact-cta">
              <Button 
                size="lg" 
                className="bg-[#00A878] hover:bg-[#065F46] text-white rounded-full px-8 py-6 text-lg font-semibold"
              >
                Contact Us Today
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Join Our Team */}
      <section className="py-16 bg-white" data-testid="join-team">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-[#0F172A] mb-4">
            Join Our Team
          </h2>
          <p className="text-lg text-[#334155] mb-8 max-w-2xl mx-auto">
            We're always looking for compassionate, skilled healthcare professionals 
            to join our team. If you're passionate about making a difference in 
            seniors' lives, we'd love to hear from you.
          </p>
          <Link to="/contact" data-testid="careers-cta">
            <Button 
              variant="outline"
              size="lg" 
              className="border-2 border-[#000080] text-[#000080] hover:bg-[#000080] hover:text-white rounded-full px-8"
            >
              Explore Career Opportunities
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Team;
